import axios from 'axios';
import type { AppointmentStatus } from '@bb/domain/dist/types';

const setStatusByCoop = async (
  appointmentId: string,
  options: {
    status: AppointmentStatus;
    details?: string;
  },
) => {
  await axios.post(`/user/coop/appointments/${appointmentId}/status`, {
    ...options,
  });
};

export default setStatusByCoop;
